<template>
    <div class="carousel-slide w-full shrink-0">
        <slot />
    </div>
</template>
